import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import '../GuruTradesChart/GuruTradesChart.css';
import '../CashChart/CashChart.css';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const CashChart = () => {
  // Sample data
  const data = {
    labels: ['2024-12-01', '2024-12-02', '2024-12-03', '2024-12-04', '2024-12-05', '2024-12-06', '2024-12-07', '2024-12-08', '2024-12-09', '2024-12-10', '2024-12-11', '2024-12-12'],
    datasets: [
      {
        label: 'Operating Cash Flow',
        data: [100, 120, 110, 105, 130, 140, 135, 125, 115, 110, 145, 150], // Operating Cash Flow data
        backgroundColor: '#f1bf42', // Blue bars
        yAxisID: 'y1',
        barPercentage: 0.5,
        barThickness: 10,
        maxBarThickness: 8,
        categoryPercentage: 0.50, // Increased gap between bars
      },
      {
        label: 'Free Cash Flow',
        data: [80, 90, 85, 80, 100, 110, 105, 95, 85, 80, 115, 120], // Free Cash Flow data
        backgroundColor: '#5383ec', // Green bars
        yAxisID: 'y1',
        barPercentage: 0.5,
        barThickness: 10,
        maxBarThickness: 8,
        categoryPercentage: 0.50, // Increased gap between bars
      },
      {
        label: 'EBITDA Net Income',
        data: [60, 65, 55, 58, 70, 68, 66, 62, 64, 60, 72, 75], // EBITDA Net Income data
        backgroundColor: '#58a65c', // Yellow bars
        yAxisID: 'y1',
        barPercentage: 0.5,
        barThickness: 10,
        maxBarThickness: 8,
        categoryPercentage: 0.2,
      },
      {
        label: 'Cash Flow for Dividends',
        data: [-40, -45, -35, -38, -50, -48, -46, -42, -44, -40, -52, -55], // Cash Flow for Dividends data (negative values)
        backgroundColor: '#7264ea', // Red bars
        yAxisID: 'y1',
        barPercentage: 0.5,
        barThickness: 10,
        maxBarThickness: 8,
        categoryPercentage: 0.50, // Increased gap between bars
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      title: {
        display: false,
        text: 'Cash Flow Overview: Operating Cash Flow, Free Cash Flow, EBITDA Net Income, Cash Flow for Dividends',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        backgroundColor: 'white', // White background
        titleColor: 'black', // Title text color (you can change this if needed)
        bodyColor: 'black', // Body text color
        borderColor: 'black', // Border color
        borderWidth: 1, // Border width
        padding: 10, // Padding inside the tooltip
        caretSize: 5, // Size of the tooltip's arrow/caret
        cornerRadius: 4, // Rounded corners for the tooltip
      },
    },
    scales: {
      y: {
        display: false,
      },
      y1: {
        type: 'linear',
        position: 'right',
        beginAtZero: true,
        title: {
          display: true,
          text: 'Value (in Millions)',
        },
        ticks: {
          callback: function (value) {
            return value + 'M';
          },
        },
        grid: {
          drawOnChartArea: false,
        },
      },
      x: {
        type: 'category',
        title: {
          display: true,
          text: 'Date',
        },
      },
    },
  };

  return (
    <div className='cash-container'>
      <h2>Cash Flow Overview</h2>
      <Bar data={data} options={options} />
    </div>
  );
};

export default CashChart;
